
export type SubscribePlanChangeUpgradeGet200UpgradeInfo = {
  effectiveDate?: string;
  fromPlan?: string;
  priceDifference?: number;
  toPlan?: string;
};
